import React from 'react';
export default (function (_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React.createElement("h1", null, title);
});